<template>
  <div class="home">
    <Header />
    <Search ref="search" @searchJobmain="searchJobmain" @setVal="setVal" />
    <Jobs :isTop="true" />
    <Jobs ref="jobs" :isTop="false" :datee="date" :cityId='cityId' :provinceId="provinceId" :slaryStart='slaryStart' :slaryEnd='slaryEnd' :jobType='jobType' :company="company" :searchVal="searchVal" />
    <!-- <Swipe ref="swipe"  />
    <Content @opend="opend" />  -->
    <Footter />
    <!-- <router-view /> -->
    <!-- <Menu /> -->
    <!-- <img alt="Vue logo" @click="getProvince" src="../assets/logo.png">
    <img alt="Vue logo" @click="getEducation" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App xiaojj" /> -->

  </div>
</template>

<script>
// @ is an alias to /src
import Header from './Header.vue';
import Search from './Search.vue';
import Jobs from './Jobs.vue';
import Footter from './footter.vue';

export default {
  name: 'Home',
  data() {
    return {
      proList: [],
      date: '',
      cityId: '',
      provinceId: '',
      slaryStart: '',
      slaryEnd: '',
      jobType: '',
      searchVal: '',
      company:''
    };
  },
  components: {
    Header,
    Search,
    Jobs,
    Footter,
  },
  created() {
    // if (!this.$store.state.token) {
    //   this.$router.push({
    //     path: '/login'
    //   });
    // }
    this.date = this.getDate(3);
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // console.log(this.$refs['search'].dateVal);
    // console.log(this.$refs['search'].city);
    // console.log(this.$refs['search'].slaryStart);
    // console.log(this.$refs['search'].slaryEnd);
    // console.log(this.$refs['search'].jobType);
  },
  updated() {
    // console.log(this.$refs['search'].dateVal);
    // console.log(this.$refs['search'].city);
    // console.log(this.$refs['search'].slaryStart);
    // console.log(this.$refs['search'].slaryEnd);
    // console.log(this.$refs['search'].jobType);
  },
  methods: {
    setVal() {
      // console.log(111)
      // console.log(this.$refs['search'].dateVal);
      // console.log(this.$refs['search'].city);
      // console.log(this.$refs['search'].slaryStart);
      // console.log(this.$refs['search'].slaryEnd);
      // console.log(this.$refs['search'].jobType);

      if (this.$refs['search'].city.name == '全境') {
        this.provinceId = this.$refs['search'].city.id;
        this.cityId = 0;
      } else {
        this.cityId = this.$refs['search'].city.id;
        this.provinceId = 0;
      }
      this.searchVal = this.$refs['search'].searchVal;
      this.slaryStart = this.$refs['search'].slaryStart;
      this.slaryEnd = this.$refs['search'].slaryEnd;
      // this.jobType = this.$refs['search'].jobType;
      this.jobType = this.$refs['search'].jobTypeVal;
      this.company = this.$refs['search'].company;
      switch (this.$refs['search'].dateVal) {
        case '最近三个月':
          this.date = this.getDate(3);
          break;
        case '最近一个月':
          this.date = this.getDate(1);
          break;
        case '最近半年':
          this.date = this.getDate(6);
          break;
        case '最近一年':
          this.date = this.getDate(12);
          break;
        default:
          break;
      }
    },
    searchJobmain() {
      // this.date = this.$refs['search'].dateVal;
      // console.log(this.$refs['search'].dateVal);
      // console.log(this.$refs['search'].city);
      // console.log(this.$refs['search'].slaryStart);
      // console.log(this.$refs['search'].slaryEnd);
      // console.log(this.$refs['search'].jobType);
      // this.cityId = this.$refs['search'].city.id;
      // console.log(this.$refs['search'])

      this.$refs['jobs'].getJobs(1);
    },
    getDate(n) {
      var dt = new Date();
      dt.setMonth(dt.getMonth() - n);
      return this.$until.getDateStr(dt.getTime() / 1000, '-');
    },
    opend() {
      console.log('ok');
      this.$refs['swipe'].openDrawf();
    },
    async getProvince() {
      let result = await this.$api.instance.getProvince();
      console.log(result);
    },
    async getEducation() {
      let result = await this.$api.instance.getEducation();
      console.log(result);
    },
    async getStudentApply() {
      let params = {
        page: 1,
        size: 100,
      };
      let result = await this.$api.instance.getStudentApply(params);
      console.log(result);
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  height: 100vh;
  width: 100%;
  // overflow-x: hidden;
  // background: #acbfa8;
}
</style>
